export default "__VITE_ASSET__D3oMF$rw__"